import { put, select, takeLatest } from 'redux-saga/effects'
import { getProcedureStateSelector } from '../../../../components/procedure/selectors'
import { setInputRows } from '../../../../components/procedure/store/procedure.actions'
import { IProcedureState } from '../../../../components/procedure/store/procedure.types'
import { getDrainSelector } from '../selectors'
import { DrainActionIds, DrainConstants } from '../store/drain.constants'
import { IDrainState } from '../store/drain.types'

type DrainActionMap = Record<string, Array<DrainActionIds>>

const VISIBLE_FOR_ACTIONS: DrainActionMap = {
  [DrainConstants.SET_PROCEDURE]: [DrainActionIds.CHEST_TUBE],
  [DrainConstants.SET_CHEST_SUCTION]: [DrainActionIds.CHEST_TUBE],
  [DrainConstants.SET_DEPTH]: [DrainActionIds.CHEST_TUBE],
  [DrainConstants.SET_DRAIN_SUCTION]: [DrainActionIds.NG_TUBE, DrainActionIds.OG_TUBE],
  [DrainConstants.SET_CSF_COLOR]: [DrainActionIds.VENTRICULOSTOMY],
  [DrainConstants.SET_FOLEY_COLOR]: [DrainActionIds.FOLEY],
  [DrainConstants.SET_SIDE]: [
    DrainActionIds.NG_TUBE,
    DrainActionIds.CHEST_TUBE,
    DrainActionIds.NEEDLE_THORACOSTOMY,
    DrainActionIds.SIMPLE_FINGER_THORACOSTOMY,
  ],
  [DrainConstants.SET_LOCATION]: [DrainActionIds.NEEDLE_THORACOSTOMY, DrainActionIds.SIMPLE_FINGER_THORACOSTOMY],
  [DrainConstants.SET_INTERCOSTAL_SPACE]: [
    DrainActionIds.NEEDLE_THORACOSTOMY,
    DrainActionIds.SIMPLE_FINGER_THORACOSTOMY,
  ],
}

const HIDDEN_FOR_ACTIONS: DrainActionMap = {
  [DrainConstants.SET_SIZE]: [
    DrainActionIds.ILEOSTOMY,
    DrainActionIds.COLOSTOMY,
    DrainActionIds.SIMPLE_FINGER_THORACOSTOMY,
  ],
  [DrainConstants.SET_SIZE_UNIT]: [
    DrainActionIds.ILEOSTOMY,
    DrainActionIds.COLOSTOMY,
    DrainActionIds.SIMPLE_FINGER_THORACOSTOMY,
    DrainActionIds.NEEDLE_THORACOSTOMY,
  ],
}

const isInputHidden = (inputKey: string, actionId: DrainActionIds | null): boolean | undefined => {
  const visibleFor = VISIBLE_FOR_ACTIONS[inputKey]
  if (visibleFor) {
    return !actionId || !visibleFor.includes(actionId)
  }

  const hiddenFor = HIDDEN_FOR_ACTIONS[inputKey]
  if (hiddenFor) {
    return !actionId || hiddenFor.includes(actionId)
  }

  return undefined
}

export function* setAction() {
  const procedureState: IProcedureState = yield select(getProcedureStateSelector)
  const drainState: IDrainState = yield select(getDrainSelector)
  const { inputRows } = procedureState
  const { action } = drainState

  const actionId = action ? (String(action.id) as DrainActionIds) : null

  inputRows.forEach((row) =>
    row.inputs.forEach((input) => {
      const hidden = isInputHidden(input.key, actionId)
      if (hidden !== undefined) {
        input.hidden = hidden
      }
    })
  )
  yield put(setInputRows(inputRows))
}

export function* setActionSaga() {
  yield takeLatest([DrainConstants.SET_ACTION, DrainConstants.SET_UPDATE_INPUT_ROWS], setAction)
}
